module.exports = __webpack_public_path__ + "img/give-money.a93cf803.png";